import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import PageLoader from "../../../../../../components/PageLoader";
import { selectListItems } from "../../../../../../redux/library/selector";
import { selectReceiptsListItems } from "../../../../../../redux/fms/receipts/selector";
import { receipts } from "../../../../../../redux/fms/receipts/action";

const ManagementReceipts = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const receiptsListData = useSelector(selectReceiptsListItems)
  const libraryData = useSelector(selectListItems)
  const [columnDefs, setColumnDefs] = useState({});

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'ReceiptNumber', headerName: 'Receipt Number', searchField: 'ReceiptNumber', sortable: true, filter: true, filterType: 'number' },
      { field: 'LedgerName', headerName: 'Ledger Name', searchField: 'LedgerName', sortable: true, filter: true, filterType: 'text' },
      { field: 'AccountName', headerName: 'Account Name', searchField: 'AccountName', sortable: true, filter: true, filterType: 'text' },
      { field: 'AccountType', headerName: 'Account Type' },
      { field: 'VoucherTransactionTypeId', headerName: 'Voucher TransactionType', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraryData?.result?.VoucherTransactionType } },
      { field: 'PaymentTransactionTypeId', headerName: 'Payment TransactionType', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraryData?.result?.PaymentTransactionType } },
      { field: 'PaidDateOnUtc', headerName: 'Paid on Date/Time', isDateValueFormat: true },
      { field: 'ReceiptAmount', headerName: 'Receipt Amount', isCurrencyValueFormat: true },
      { field: 'LedgerTrasactionMethodId', headerName: 'Ledger Trasaction Method', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraryData?.result?.LedgerTransactionMethod } },      
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
    ]);
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }

  const handleDelete = (data: any) => {
    dispatch(receipts.delete({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/receipts/delete`,
      entity: 'receipts',
      jsonData:
      {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
    })).then(() => {
      fetchReceiptsList();
    });
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Receipt</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      // name: 'Add Receipt',
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];

  const fetchReceiptsList = () => {
    dispatch(receipts.list({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/receipts/list`,
      entity: 'receipts',
      jsonData:
      {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "CreatedOnUtc",
        "SortOrder": "desc",
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchReceiptsList()
  }, [pageData, pageSize])

  const handleReloadData = () => {
    fetchReceiptsList();
  }

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(receipts.list({
      url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/fms/receipts/list`,
      entity: 'receipts',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  const handleSelect = (item: any) => {

  }

  return (
    <>
      {receiptsListData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs} rowData={receiptsListData?.result?.items}
          setPageData={setPageData} setPageSize={setPageSize} paginationData={receiptsListData?.result?.pagination}
          enableFilter={true} onSearch={handleSearch} onSelect={handleSelect}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons}
          headingName="Receipts"
        />
      }
    </>
  );
};

export default ManagementReceipts;


